import { atom } from 'jotai'
import { DoctolibZipperStatus } from '../../model/Doctolib'

export const zipperStatusAtom = atom<DoctolibZipperStatus>(DoctolibZipperStatus.NOT_LOADED)

export const isDoctolibLoaded = atom((get) => get(zipperStatusAtom) === DoctolibZipperStatus.LOADED)
